import { Component, OnInit } from "@angular/core";
import { LocationTypeEnum } from "../core/constant";
import { StandardService } from "../services/standard.service";
import { AdminService } from "../services/admin.service";
import { ApplicationStatementModel } from "../models/application-statement";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import DOMPurify from 'dompurify';
declare var $: any;

//  (window as any).newrelic.setCustomAttribute("tags.product", "IAM");
//  (window as any).newrelic.setCustomAttribute("tags.environment", "PROD");



@Component({
  selector: "app-locations",
  templateUrl: "./locations.component.html",
  styleUrls: ["./locations.component.scss"],
})
export class LocationsComponent implements OnInit {
  get locationTypeEnum() {
    return LocationTypeEnum;
  }
  isFromLocation: boolean = true;
  isStatementExpanded: boolean = true;
  sidebarCollapsed = false;
  applicationStatement: ApplicationStatementModel = new ApplicationStatementModel();
  statement: SafeHtml = "";
  statementId: number = 1;
  constructor(
    public standardService: StandardService,
    private adminService: AdminService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {

    this.standardService.locationId = 0;
    $(document).ready(() => {
      let position;

      const highlightChunk = (objId: string, altText: string) => {
        if (!objId || $(objId).length === 0) {
          return;
        }
        if (objId == "#curbside") {
          $(".curbside").css({
            transition: "transform 1s ease",
            transform: "scale(1.1)",
          });
        } else {
          $(".curbside-img").addClass("curbside-img-filter");
        }
        $(".main-image").css("opacity", "0");
        $(".main-image-wrapper").css("z-index", "9999");
        $(objId).find("img").css("z-index", "2");
        $(objId).removeClass("d-none");
        $(objId).addClass("active");
        $(".chunk").removeClass("d-none");
        $(".tooltip-text span").text(altText);
        position = $(objId).position();
        $(".tooltip-text").css(
          "left",
          position.left + $(objId).find("img").width()
        );
        $(".tooltip-text").css("top", position.top + $(objId).height() / 2);
        $(".tooltip-text").fadeIn("fast");
      };

      const resetChunkHighlight = () => {
        $(".curbside-img").removeClass("curbside-img-filter");

        $(".curbside").css({ transform: "scale(1)" });
        $(".main-image-wrapper").css("z-index", "1");
        $(".chunk").addClass("d-none");
        $(".curbside").removeClass("d-none");
        $(".chunk").removeClass("active");
        $(".curbside").addClass("active");

        $(".main-image").css("opacity", "1");
        $(".tooltip-text").hide();
      };

      $(".image-map area")
        .mouseenter(function (e) {
          highlightChunk($(this).attr("target"), $(this).attr("alt"));
        })
        .mouseleave(function (e) {
          resetChunkHighlight();
        });

      $(".location-link[data-chunk-target]")
        .mouseenter(function (e) {
          highlightChunk(
            $(this).attr("data-chunk-target"),
            $(this).attr("data-chunk-alt")
          );
        })
        .mouseleave(function (e) {
          resetChunkHighlight();
        });
    });

    this.adminService
      .GetApplicationStatementDetailsById(this.statementId)
      .subscribe((data: ApplicationStatementModel) => {
      
        this.applicationStatement = new ApplicationStatementModel(data);
        // this.statement = this.sanitizer.bypassSecurityTrustHtml(
        //   this.applicationStatement.statementDescription
        // );
          const cleanHTML = DOMPurify.sanitize(
         this.applicationStatement.statementDescription,
         );
          this.statement = this.sanitizer.bypassSecurityTrustHtml(
        cleanHTML
        );
       
      });
  }

  toggleStatement(): void {
    this.isStatementExpanded = !this.isStatementExpanded;
  }

  toggleSidebar(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }
}
